// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 593) return "static/chunks/framework-b5e6696026971dcc.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 233 ? "three" : chunkId) + "." + {"45":"8a190d741540281f","233":"29a48b24851a261e","257":"d7551b274dc5adab","446":"5cb29c2f0d09d0c2","481":"aa2b01ede9a9e53f","581":"359a7b01db67dacc","608":"3386e247cf1fe5c2","798":"d4749042133f88ba"}[chunkId] + ".js";
};